import { z } from 'zod'

export const schema = z.object({
  hasError: z.boolean(),
})

export type schemaType = z.infer<typeof schema>
